<template>
    <validation-observer v-slot="{ invalid, handleSubmit }" ref="issueValidator">
        <form @submit.prevent="handleSubmit(submit)" @keydown="errors.clear($event.target.name)">

            <div class="row" v-if="!timeslot">
                <time-input class="col-6"
                    :label="$t('logs.from')"
                    v-model="value.log_time_from"
                    name="log_time_from"
                    :error="errors.get('log_time_from')">
                </time-input>

                <time-input class="col-6"
                    :label="$t('logs.to')"
                    v-model="value.log_time_to"
                    name="log_time_to"
                    :error="errors.get('log_time_to')">
                </time-input>
            </div>

            <base-input class="mb-3" v-if="!timeslot"
                :label="$t('feedbacks.summary')"
                :placeholder="$t('feedbacks.summary')"
                v-model="value.summary"
                name="summary"
                :error="errors.get('summary')">
            </base-input>

            <base-input class="mb-3"
                :label="$t('common.description')"
                label-classes="form-control-label required"
                rules="required"
                name="public_description"
                :error="errors.get('public_description')"
            >
                <textarea class="form-control" rows="5"
                    :placeholder="$t('common.description')"
                    v-model="value.description"
                ></textarea>
            </base-input>

            <div class="category form-category mb-4">
                <small><span class="text-warning">*</span> {{ $t('common.required-fields') }}</small>
            </div>

            <div class="text-center">
                <base-button native-type="submit"
                    type="primary"
                    :disabled="errors.any() || invalid"
                >
                    {{ value.id ? $t('common.update') : $t('common.create') }}
                </base-button>

                <base-button type="link" class="ml-auto" @click="modal.show = false">
                    {{ $t('common.cancel') }}
                </base-button>
            </div>

        </form>
    </validation-observer>
</template>

<script>
    export default {
        
        props: {

            value: {
                type: Object,
                required: true
            },

            errors: {
                type: Object,
                required: true
            },

            modal: {
                type: Object,
                required: true
            },

            timeslot: {
                type: Object,
                default: null
            },
        },

        created() {
            this.errors.setValidator('issueValidator', this)
        },

        methods: {
            submit() {
                this.$emit('input', { ...this.value})
            }
        }
    }
</script>
